import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import api from "../../services/api";

export const setDashboardMarker = createAction("SET_DASHBOARD_MARKER");
export const updateDashboardUser = createAction("UPDATE_DASHBOARD_USER");
export const removeDashboardUser = createAction("REMOVE_DASHBOARD_USER");

export const clearAllDashboardData = createAction("CLEAR_ALL_DASHBOARD_DATA");

export const fetchDashboardUsers = createAsyncThunk(
  "dashboard/fetchUsersProductivity",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        "/activedtasks/dashboard/productivity/users"
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchDashboardTasks = createAsyncThunk(
  "dashboard/fetchTasksProductivity",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        "/activedtasks/dashboard/productivity/tasks"
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchDashboardFlows = createAsyncThunk(
  "dashboard/fetchFlowsProductivity",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        "/activedtasks/dashboard/productivity/flows"
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchDashboardChat = createAsyncThunk(
  "dashboard/fetchChatProductivity",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        "/activedtasks/dashboard/productivity/chat"
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const handleUpdateDashboardUser = ({ userId, updates }) => {
  return (dispatch) =>
    api
      .put("/dashboard/users/" + userId, updates)
      .then((res) => dispatch(updateDashboardUser(res.data)))
      .catch((err) => Promise.reject(err));
};

export const handleRemoveDashboardUser = ({ userId }) => {
  return (dispatch) =>
    api
      .delete("/dashboard/users/" + userId)
      .then((res) => dispatch(removeDashboardUser(res.data)))
      .catch((err) => Promise.reject(err));
};
